import { ColumnModel } from '../../modules/api/api.models'
import { SortType } from '../../helpers/common-helper'

export class ColumnInfo {
    SortType: number
    IdDataType: number
    Filter: string[]
    Name: string
    Description: string
    IsVisible: boolean

    // TODO: remove ColumnModel
    constructor(model: ColumnModel) {
        if (model != null) {
            this.SortType = model.sortDesc != null ? (model.sortDesc == true ? SortType.Desc : SortType.Asc) : SortType.None

            this.IdDataType = model.id
            this.Filter = model.where
            this.Name = model.name.toUpperCase()
            this.Description = model.caption
            this.IsVisible = !model.hidden
        }
    }
}